import { Box, Flex, customStyled } from '@mafc/trolly';

export const Text = customStyled(Box)(({ theme }) => ({
  color: theme.colors.black,
  fontSize: theme.fontSizes[2],
}));

export const EarnedPointsText = customStyled(Flex)`
  margin-left:  ${props => props.theme.space[2]}px;
  max-width: 180px;

  @media (min-width: ${props => props.theme.breakpoints[2]}) {
    max-width: 100%;
  }
`;

export const Points = customStyled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights[8],
}));

export const IconWrapper = customStyled(Flex)(() => ({
  alignItems: 'center',
}));
